// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_a4ba041d"};